import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Row, Col, Typography, Space, Rate } from 'antd';
import Reveal from '../../../components/reveal/Reveal';
import {
    CarOutlined,
    HomeOutlined,
    MedicineBoxOutlined,
    ToolOutlined,
    SafetyOutlined,
    RocketOutlined,
    ArrowRightOutlined,
    PhoneOutlined,
    CheckCircleOutlined,
    FileProtectOutlined,
    TeamOutlined,
    DollarOutlined,
    ThunderboltOutlined,
    CustomerServiceOutlined,
    LikeOutlined,
    TrophyOutlined,
    ClockCircleOutlined,
    StarOutlined,
    UserOutlined,
    GlobalOutlined,
    SafetyCertificateOutlined,
} from '@ant-design/icons';
import './Accueil.scss';

const { Title, Paragraph, Text } = Typography;

const assurances = [
    {
        key: 'auto',
        icon: <CarOutlined />,
        title: 'Assurance Automobile',
        desc: 'Protegez votre vehicule avec nos formules adaptees : tous risques, tiers, vol et incendie. Tarifs a partir de 50 000 FCFA.',
        color: '#1A2B5F',
        tag: 'Populaire',
    },
    {
        key: 'habitation',
        icon: <HomeOutlined />,
        title: 'Assurance Habitation',
        desc: 'Securisez votre domicile contre les risques d\'incendie, de vol, de degat des eaux et catastrophes naturelles.',
        color: '#C8102E',
        tag: null,
    },
    {
        key: 'sante',
        icon: <MedicineBoxOutlined />,
        title: 'Assurance Sante',
        desc: 'Couvertures sante completes : hospitalisation, consultations, pharmacie, maternite, evacuation sanitaire.',
        color: '#2e7d32',
        tag: 'Famille',
    },
    {
        key: 'chantier',
        icon: <ToolOutlined />,
        title: 'Assurance Chantier',
        desc: 'Couvrez vos chantiers de construction : TRC, decennale, dommages aux ouvrages, RC maitre d\'ouvrage.',
        color: '#e65100',
        tag: 'Entreprise',
    },
    {
        key: 'plantation',
        icon: <SafetyOutlined />,
        title: 'Assurance Plantation',
        desc: 'Protegez vos exploitations : cacao, cafe, hevea, palmier. Couverture incendie, secheresse, inondation.',
        color: '#1b5e20',
        tag: 'Agricole',
    },
    {
        key: 'transport',
        icon: <RocketOutlined />,
        title: 'Assurance Transport',
        desc: 'Assurez vos marchandises en transit par route, mer ou air. Couverture tous risques disponible.',
        color: '#4a148c',
        tag: 'Entreprise',
    },
];

const etapes = [
    {
        num: '01',
        icon: <PhoneOutlined />,
        title: 'Contactez-nous',
        desc: 'Appelez-nous ou remplissez notre formulaire en ligne pour nous exposer vos besoins en assurance.',
    },
    {
        num: '02',
        icon: <FileProtectOutlined />,
        title: 'Recevez votre devis',
        desc: 'Nous comparons les offres de nos 8+ partenaires et vous proposons la meilleure couverture au meilleur prix.',
    },
    {
        num: '03',
        icon: <CheckCircleOutlined />,
        title: 'Souscrivez facilement',
        desc: 'Signez votre contrat en agence ou a distance. Votre couverture est active immediatement.',
    },
    {
        num: '04',
        icon: <CustomerServiceOutlined />,
        title: 'Accompagnement continu',
        desc: 'Gestion de vos sinistres, renouvellement, ajustements. Un conseiller dedie vous suit au quotidien.',
    },
];

const engagements = [
    {
        icon: <DollarOutlined />,
        title: 'Tarifs negocies',
        desc: 'En tant que courtier, nous obtenons des tarifs preferentiels aupres de nos compagnies partenaires. Vous economisez jusqu\'a 30% sur vos primes.',
    },
    {
        icon: <ThunderboltOutlined />,
        title: 'Rapidite',
        desc: 'Devis en 24h, souscription en 48h. En cas de sinistre, nous declenchons les procedures immediatement pour accelerer votre indemnisation.',
    },
    {
        icon: <SafetyCertificateOutlined />,
        title: 'Independance',
        desc: 'Nous ne sommes lies a aucune compagnie. Notre seul objectif : defendre vos interets et vous trouver la couverture la plus adaptee.',
    },
    {
        icon: <TeamOutlined />,
        title: 'Proximite',
        desc: '2 agences a Abidjan (Vallon et Riviera Golf), une equipe de conseillers dedies et disponibles pour vous accompagner.',
    },
];

const temoignages = [
    {
        nom: 'Kouame A.',
        role: 'Chef d\'entreprise',
        text: 'CAP Assurances m\'a permis de trouver une assurance tous risques pour ma flotte de vehicules a un tarif tres competitif. Leur accompagnement lors d\'un sinistre a ete exemplaire.',
        rating: 5,
    },
    {
        nom: 'Mme Bamba S.',
        role: 'Proprietaire',
        text: 'Je suis cliente depuis 3 ans pour mon assurance habitation et sante. Le service est toujours professionnel et les conseillers tres reactifs.',
        rating: 5,
    },
    {
        nom: 'Traore M.',
        role: 'Exploitant agricole',
        text: 'Grace a l\'assurance plantation de CAP, j\'ai pu etre indemnise rapidement apres un incendie sur ma parcelle. Je recommande vivement.',
        rating: 5,
    },
];

const partenaires = [
    'SUNU Assurances',
    'NSIA Assurances',
    'AXA Assurances',
    'ATLANTA Assurances',
    'GNA Assurances',
    'SALAM Assurances',
    'SERENITY Assurances',
    'NOVELIA Assurances',
];

const ciblesParticuliers = [
    'Assurance auto obligatoire et tous risques',
    'Protection de votre habitation et biens',
    'Couverture sante individuelle et familiale',
    'Assurance voyage et assistance',
];

const ciblesEntreprises = [
    'Flotte automobile et parc de vehicules',
    'Responsabilite civile professionnelle',
    'Multirisque bureaux et locaux',
    'Assurance chantier et transport de marchandises',
    'Couverture sante pour vos employes',
];

export default function Accueil() {
    const navigate = useNavigate();
    const [heroReady, setHeroReady] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setHeroReady(true), 100);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="page-accueil">
            {/* Hero Section */}
            <section className={`hero-section ${heroReady ? 'hero-ready' : ''}`}>
                <div className="hero-content">
                    <div className="hero-grid">
                        <div className="hero-left">
                            <div className="hero-badge">
                                <TrophyOutlined /> Courtier d'assurances agree en Cote d'Ivoire
                            </div>
                            <Title level={1} className="hero-title">
                                Protegez ce qui compte<br />
                                <span className="hero-highlight">au meilleur prix</span>
                            </Title>
                            <Paragraph className="hero-subtitle">
                                CAP Assurances compare les offres de <strong>8+ compagnies partenaires</strong> pour
                                vous garantir la meilleure couverture au tarif le plus competitif.
                                Particuliers et entreprises, nous avons la solution qu'il vous faut.
                            </Paragraph>
                            <Space size={16} wrap>
                                <Button type="primary" size="large" onClick={() => navigate('/contact')} className="hero-btn-primary">
                                    Demander un devis gratuit
                                </Button>
                                <Button size="large" ghost onClick={() => navigate('/assurances')} className="hero-btn-ghost">
                                    Voir nos assurances
                                </Button>
                            </Space>
                            <div className="hero-trust">
                                <div className="trust-item">
                                    <StarOutlined /> <strong>Devis gratuit</strong> sans engagement
                                </div>
                                <div className="trust-item">
                                    <ClockCircleOutlined /> Reponse sous <strong>24h</strong>
                                </div>
                                <div className="trust-item">
                                    <LikeOutlined /> <strong>100%</strong> independant
                                </div>
                            </div>
                        </div>

                        <div className="hero-right">
                            <div className="hero-visual">
                                {/* Carte principale */}
                                <div className="float-card main-card" onClick={() => navigate('/assurances/auto')}>
                                    <div className="float-card-icon auto"><CarOutlined /></div>
                                    <div className="float-card-info">
                                        <strong>Assurance Auto</strong>
                                        <span>A partir de 50 000 FCFA</span>
                                    </div>
                                    <ArrowRightOutlined className="float-card-arrow" />
                                </div>

                                <div className="float-card second-card" onClick={() => navigate('/assurances/sante')}>
                                    <div className="float-card-icon sante"><MedicineBoxOutlined /></div>
                                    <div className="float-card-info">
                                        <strong>Assurance Sante</strong>
                                        <span>Individuel & Famille</span>
                                    </div>
                                    <ArrowRightOutlined className="float-card-arrow" />
                                </div>

                                <div className="float-card third-card" onClick={() => navigate('/assurances/habitation')}>
                                    <div className="float-card-icon habitation"><HomeOutlined /></div>
                                    <div className="float-card-info">
                                        <strong>Assurance Habitation</strong>
                                        <span>Locataire & Proprietaire</span>
                                    </div>
                                    <ArrowRightOutlined className="float-card-arrow" />
                                </div>

                                {/* Stats flottantes */}
                                <div className="float-stat stat-1">
                                    <div className="stat-number">8+</div>
                                    <div className="stat-label">Partenaires</div>
                                </div>

                                <div className="float-stat stat-2">
                                    <div className="stat-number">14</div>
                                    <div className="stat-label">Produits</div>
                                </div>

                                {/* Cercle decoratif */}
                                <div className="hero-circle circle-1" />
                                <div className="hero-circle circle-2" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Offres Section */}
            <section className="section offres-section">
                <div className="section-inner">
                    <Reveal animation="fadeUp">
                        <div className="section-header">
                            <Title level={2}>Nos solutions d'assurances</Title>
                            <div className="section-line" />
                            <Paragraph className="section-desc">
                                Des couvertures adaptees a chaque besoin, negociees au meilleur tarif
                                aupres des plus grandes compagnies d'assurances
                            </Paragraph>
                        </div>
                    </Reveal>

                    <Row gutter={[24, 24]}>
                        {assurances.map((item, idx) => (
                            <Col xs={24} sm={12} lg={8} key={item.key}>
                                <Reveal animation="fadeUp" delay={idx * 100}>
                                    <Card
                                        hoverable
                                        className="assurance-card"
                                        onClick={() => navigate(`/assurances/${item.key}`)}
                                    >
                                        {item.tag && <span className="card-tag" style={{ background: item.color }}>{item.tag}</span>}
                                        <div className="card-icon" style={{ background: item.color }}>
                                            {item.icon}
                                        </div>
                                        <Title level={4} className="card-title">{item.title}</Title>
                                        <Paragraph className="card-desc">{item.desc}</Paragraph>
                                        <Button type="link" className="card-link">
                                            Decouvrir cette offre <ArrowRightOutlined />
                                        </Button>
                                    </Card>
                                </Reveal>
                            </Col>
                        ))}
                    </Row>

                    <Reveal animation="fadeIn" delay={400}>
                        <div style={{ textAlign: 'center', marginTop: 40 }}>
                            <Button size="large" onClick={() => navigate('/assurances')}>
                                Voir toutes nos assurances <ArrowRightOutlined />
                            </Button>
                        </div>
                    </Reveal>
                </div>
            </section>

            {/* Particuliers & Entreprises */}
            <section className="section cibles-section">
                <div className="section-inner">
                    <Reveal animation="fadeUp">
                        <div className="section-header">
                            <Title level={2}>Des offres pour tous les profils</Title>
                            <div className="section-line" />
                        </div>
                    </Reveal>
                    <Row gutter={[32, 32]}>
                        <Col xs={24} md={12}>
                            <Reveal animation="fadeLeft" delay={100}>
                                <Card className="cible-card particulier" bordered={false}>
                                    <div className="cible-icon-wrap"><UserOutlined /></div>
                                    <Title level={3}>Particuliers</Title>
                                    <Paragraph>
                                        Vous etes un particulier ? Nous vous proposons des assurances
                                        adaptees a votre quotidien et a votre budget.
                                    </Paragraph>
                                    <ul className="cible-list">
                                        {ciblesParticuliers.map((c, i) => (
                                            <li key={i}><CheckCircleOutlined /> {c}</li>
                                        ))}
                                    </ul>
                                    <Button type="primary" size="large" onClick={() => navigate('/contact')}>
                                        Obtenir un devis particulier
                                    </Button>
                                </Card>
                            </Reveal>
                        </Col>
                        <Col xs={24} md={12}>
                            <Reveal animation="fadeRight" delay={200}>
                                <Card className="cible-card entreprise" bordered={false}>
                                    <div className="cible-icon-wrap entreprise"><GlobalOutlined /></div>
                                    <Title level={3}>Entreprises</Title>
                                    <Paragraph>
                                        Professionnels et entreprises, securisez votre activite avec
                                        des solutions sur mesure pour votre secteur.
                                    </Paragraph>
                                    <ul className="cible-list">
                                        {ciblesEntreprises.map((c, i) => (
                                            <li key={i}><CheckCircleOutlined /> {c}</li>
                                        ))}
                                    </ul>
                                    <Button size="large" className="btn-navy" onClick={() => navigate('/contact')}>
                                        Obtenir un devis entreprise
                                    </Button>
                                </Card>
                            </Reveal>
                        </Col>
                    </Row>
                </div>
            </section>

            {/* Comment ca marche */}
            <section className="section steps-section">
                <div className="section-inner">
                    <Reveal animation="fadeUp">
                        <div className="section-header">
                            <Title level={2}>Comment ca marche ?</Title>
                            <div className="section-line" />
                            <Paragraph className="section-desc">
                                En 4 etapes simples, souscrivez votre assurance au meilleur prix
                            </Paragraph>
                        </div>
                    </Reveal>

                    <div className="steps-grid">
                        {etapes.map((etape, i) => (
                            <Reveal animation="fadeUp" delay={i * 150} key={i}>
                                <div className="step-card">
                                    <div className="step-num">{etape.num}</div>
                                    <div className="step-icon">{etape.icon}</div>
                                    <Title level={4}>{etape.title}</Title>
                                    <Paragraph className="step-desc">{etape.desc}</Paragraph>
                                </div>
                            </Reveal>
                        ))}
                    </div>

                    <Reveal animation="fadeIn" delay={500}>
                        <div style={{ textAlign: 'center', marginTop: 40 }}>
                            <Button type="primary" size="large" onClick={() => navigate('/contact')} icon={<PhoneOutlined />}>
                                Demarrer maintenant - C'est gratuit
                            </Button>
                        </div>
                    </Reveal>
                </div>
            </section>

            {/* Nos engagements */}
            <section className="section engagements-section">
                <div className="section-inner">
                    <Reveal animation="fadeUp">
                        <div className="section-header">
                            <Title level={2}>Nos engagements envers vous</Title>
                            <div className="section-line" />
                            <Paragraph className="section-desc">
                                Ce qui fait la difference quand vous choisissez un courtier comme CAP Assurances
                            </Paragraph>
                        </div>
                    </Reveal>

                    <Row gutter={[24, 24]}>
                        {engagements.map((e, i) => (
                            <Col xs={24} sm={12} lg={6} key={i}>
                                <Reveal animation="scaleIn" delay={i * 120}>
                                    <div className="engagement-card">
                                        <div className="engagement-icon">{e.icon}</div>
                                        <Title level={4}>{e.title}</Title>
                                        <Paragraph>{e.desc}</Paragraph>
                                    </div>
                                </Reveal>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            {/* Pourquoi nous - Chiffres */}
            <section className="section why-section">
                <div className="section-inner">
                    <Row gutter={[48, 32]} align="middle">
                        <Col xs={24} lg={12}>
                            <Reveal animation="fadeLeft">
                                <Title level={2}>Pourquoi plus de clients nous font confiance ?</Title>
                                <div className="section-line left" />
                                <Paragraph style={{ fontSize: 16, marginBottom: 16 }}>
                                    En tant que courtier independant, <strong>nous travaillons pour vous</strong>,
                                    pas pour les compagnies d'assurances. Notre mission : vous trouver la
                                    couverture ideale au prix le plus juste.
                                </Paragraph>
                                <Paragraph style={{ fontSize: 16, marginBottom: 24 }}>
                                    Nous comparons les offres, negocions les tarifs, et gerons vos sinistres
                                    avec la meme exigence que si c'etait les notres.
                                </Paragraph>
                                <Space size={16} wrap>
                                    <Button type="primary" size="large" onClick={() => navigate('/contact')}>
                                        Demander un devis
                                    </Button>
                                    <Button size="large" onClick={() => navigate('/a-propos')}>
                                        Decouvrir CAP Assurances
                                    </Button>
                                </Space>
                            </Reveal>
                        </Col>
                        <Col xs={24} lg={12}>
                            <Reveal animation="fadeRight" delay={200}>
                                <div className="why-visual">
                                    <div className="visual-card">
                                        <Title level={1} className="visual-number">8+</Title>
                                        <Text>Compagnies partenaires</Text>
                                    </div>
                                    <div className="visual-card accent">
                                        <Title level={1} className="visual-number">14</Title>
                                        <Text>Types d'assurances</Text>
                                    </div>
                                    <div className="visual-card accent">
                                        <Title level={1} className="visual-number">2</Title>
                                        <Text>Agences a Abidjan</Text>
                                    </div>
                                    <div className="visual-card">
                                        <Title level={1} className="visual-number">24h</Title>
                                        <Text>Delai de reponse</Text>
                                    </div>
                                </div>
                            </Reveal>
                        </Col>
                    </Row>
                </div>
            </section>

            {/* Temoignages */}
            <section className="section temoignages-section">
                <div className="section-inner">
                    <Reveal animation="fadeUp">
                        <div className="section-header">
                            <Title level={2}>Ce que disent nos clients</Title>
                            <div className="section-line" />
                            <Paragraph className="section-desc">
                                La satisfaction de nos clients est notre meilleure recompense
                            </Paragraph>
                        </div>
                    </Reveal>

                    <Row gutter={[24, 24]}>
                        {temoignages.map((t, i) => (
                            <Col xs={24} md={8} key={i}>
                                <Reveal animation="fadeUp" delay={i * 150}>
                                    <Card className="temoignage-card" bordered={false}>
                                        <Rate disabled defaultValue={t.rating} className="temoignage-rating" />
                                        <Paragraph className="temoignage-text">"{t.text}"</Paragraph>
                                        <div className="temoignage-author">
                                            <div className="author-avatar">{t.nom.charAt(0)}</div>
                                            <div>
                                                <Text strong>{t.nom}</Text>
                                                <br />
                                                <Text type="secondary" style={{ fontSize: 13 }}>{t.role}</Text>
                                            </div>
                                        </div>
                                    </Card>
                                </Reveal>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            {/* Partenaires */}
            <section className="section partenaires-section">
                <div className="section-inner">
                    <Reveal animation="fadeUp">
                        <div className="section-header">
                            <Title level={2}>Ils nous font confiance</Title>
                            <div className="section-line" />
                            <Paragraph className="section-desc">
                                Nous travaillons avec les compagnies d'assurances les plus reconnues
                                en Cote d'Ivoire et en Afrique de l'Ouest
                            </Paragraph>
                        </div>
                    </Reveal>

                    <div className="partenaires-grid">
                        {partenaires.map((p, i) => (
                            <Reveal animation="scaleIn" delay={i * 80} key={i}>
                                <div className="partenaire-item">
                                    <GlobalOutlined className="partenaire-icon" />
                                    <Text strong>{p}</Text>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <Reveal animation="fadeIn">
                <section className="cta-section">
                    <div className="section-inner" style={{ textAlign: 'center' }}>
                        <Title level={2} style={{ color: '#fff', fontSize: 32 }}>
                            Pret a proteger ce qui compte le plus ?
                        </Title>
                        <Paragraph style={{ color: 'rgba(255,255,255,0.9)', fontSize: 17, maxWidth: 650, margin: '0 auto 8px' }}>
                            Obtenez un devis gratuit et sans engagement en moins de 24h.
                            Nos conseillers sont a votre disposition pour vous accompagner.
                        </Paragraph>
                        <Paragraph style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14, marginBottom: 32 }}>
                            +225 07 00 00 00 00 | contact@capassurances-sc.net
                        </Paragraph>
                        <Space size={16} wrap>
                            <Button
                                size="large"
                                style={{ background: '#fff', color: '#C8102E', fontWeight: 600, height: 48, paddingInline: 32 }}
                                icon={<PhoneOutlined />}
                                onClick={() => navigate('/contact')}
                            >
                                Demander un devis gratuit
                            </Button>
                            <Button
                                size="large"
                                ghost
                                style={{ height: 48, paddingInline: 32 }}
                                onClick={() => navigate('/connexion')}
                            >
                                Acceder a mon espace client
                            </Button>
                        </Space>
                    </div>
                </section>
            </Reveal>
        </div>
    );
}
